import { IArticle } from '@pressreader/content-types';

enum FeedCursorType {
    Section,
    Article,
}

interface IFeedCursor<TType = FeedCursorType> {
    cursorUniqKey: string;

    sourceKey: string;

    feedItemUniqKey: string;
    cursorType: TType;
}

interface IFeedCursorToSection extends IFeedCursor<FeedCursorType.Section> {
    sectionId: string;
}

interface IFeedCursorToArticle extends IFeedCursor<FeedCursorType.Article> {
    articleId: string;
    /**
     * Language of this article's feed copy in this feed context.
     *
     * A pick made on the article never rewrites it: a pick belongs to the article itself
     * (`articles[articleId].currentLanguage`). Host-context normalisation may set it when a cursor is anchored to a
     * host feed.
     */
    language: IArticle['language'];
}

type AnyFeedCursor = IFeedCursorToSection | IFeedCursorToArticle;

export const isFeedCursorToArticle = (cursor?: AnyFeedCursor | null): cursor is IFeedCursorToArticle => cursor?.cursorType === FeedCursorType.Article;

export { AnyFeedCursor, FeedCursorType, IFeedCursorToArticle, IFeedCursorToSection };
